<div id="loader-container">
    <div id="loader"></div>
</div>
<div id="content" class="animate-bottom">
    <router-outlet></router-outlet>
</div>